export const updateChoiceSequence = `mutation($model : [UpdateSequenceRequest!]){
    updateChoiceSequence(input : $model) 
  }`
